import React from 'react';
import { Ship } from '../../interfaces/types';
import { compareShipAttributes } from '../../utils/shipComparison';
import './ShipComparison.css';
import { FaStar } from 'react-icons/fa';

interface ShipComparisonProps {
  ships: Ship[];
}

export const ShipComparison: React.FC<ShipComparisonProps> = ({ ships }) => {
  const comparison = compareShipAttributes(ships);

  // Función auxiliar para verificar si un valor está vacío
  const isEmptyValue = (value: any) => {
    return value === null || value === undefined || value === 0 || value === '-' || value === '(-)';
  };

  // Función auxiliar para verificar si todos los valores son iguales o están vacíos
  const areAllValuesEqual = (values: any[]) => {
    if (values.length <= 1) return true;
    
    // Si todos los valores están vacíos, considerarlos iguales
    if (values.every(isEmptyValue)) return true;

    // Convertir los valores '-' y '(-)' a 0 para la comparación
    const normalizedValues = values.map(v => {
      if (v === '-' || v === '(-)') return 0;
      return v;
    });

    const firstValue = normalizedValues[0];
    return normalizedValues.every(v => v === firstValue);
  };

  return (
    <div className="ship-comparison">
      <table className="comparison-table">
        <thead>
          <tr>
            <th>Atributo</th>
            {ships.map(ship => (
              <th key={ship.name}>{ship.name}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.entries(comparison).map(([attr, values]) => {
            // Verificar si todos los valores son iguales
            const allValuesEqual = areAllValuesEqual(values.map(v => 
              Array.isArray(v.value) ? v.value.map(item => item.size) : v.value
            ));

            return (
              <tr key={attr}>
                <td>{attr}</td>
                {values.map((value, index) => (
                  <td 
                    key={index}
                    className={`
                      ${value.isHighest && !allValuesEqual ? 'highest' : ''} 
                      ${value.isUnique ? 'unique' : ''}
                    `}
                  >
                    {Array.isArray(value.value) ? (
                      <ul className="component-list">
                        {value.value.map((item, i) => {
                          // const itemSize = item.size === '-' || item.size === '(-)' ? 0 : item.size; // Para uso futuro
                          return (
                            <li 
                              key={i}
                              className={`
                                ${item.isHighest && !allValuesEqual ? 'highest' : ''} 
                                ${item.isUnique ? 'unique' : ''}
                              `}
                            >
                              {item.name} ({item.size})
                              {item.isHighest && !allValuesEqual && <FaStar className="best-indicator" />}
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <>
                        {value.value}
                        {value.isHighest && !allValuesEqual && <FaStar className="best-indicator" />}
                      </>
                    )}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}; 